'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Garage = function Garage(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M21.75,22.5 L18.9633674,22.5 L18.9633674,9.9 L5.03556123,9.9 L5.03556123,22.5 L2.25,22.5 L2.25,7.1 L11.9994643,1.5 L21.7489286,7.1 L21.7489286,22.5 L21.75,22.5 Z M6.42834185,11.3 L17.5705868,11.3 L17.5705868,14.1 L6.42834185,14.1 L6.42834185,11.3 L6.42834185,11.3 Z M6.42834185,15.5 L17.5705868,15.5 L17.5705868,18.3010769 L6.42834185,18.3010769 L6.42834185,15.5 L6.42834185,15.5 Z M17.5705868,19.6989231 L17.5705868,22.5 L6.42834185,22.5 L6.42834185,19.6989231 L17.5705868,19.6989231 Z"
  }));
};

var Garage$1 = iconStyles()(Garage);

module.exports = Garage$1;
